import classnames from 'classnames';
import {
  Button as V3Button,
  ButtonProps,
  ButtonSize,
} from '@stadionhq-v3/base-ui';
import styles from './button.module.scss';

export const Button = ({
  size = 'medium',
  variant = 'default',
  theme,
  onDark,
  classNames: incomingClassNames,
  ...props
}: ButtonProps) => {
  const classes = classnames(
    [
      styles.button,
      styles.buttonTokens,
      ...(size && Array.isArray(size)
        ? [styles.responsive, ...size.map((s: ButtonSize) => styles[s])]
        : [styles[size]]),
      theme?.themeId && styles[theme.themeId],
    ],
    {
      [`${styles.onDark}`]: onDark,
      [`${styles.iconOnly}`]: props.iconOnly,
      [`${styles.textButton}`]: variant === 'text-button',
    }
  );

  return (
    <V3Button
      {...props}
      size={size}
      theme={theme}
      variant={variant}
      onDark={onDark}
      classNames={[classes, ...(incomingClassNames || [])]}
    />
  );
};
